<template>
	<div class="container">
		<!-- footer -->
		<footer class="foot">
			<div class="ftdk  ward">
				<br>
				<div v-if="link!='pcpay'" class="ftLog flexC fl-cen ftSm">
					<router-link :to="{name:'pcabout', query: {id:1}}" class="ftSma">{{$t('help.title0')}}</router-link>

					<p>|</p>
					<router-link :to="{name:'pcPolicy', query: {id:3}}"
						class="ftSma">{{$t('help.title2')}}</router-link>
					<p>|</p>
					<router-link :to="{name:'pcproblem', query: {id:2}}"
						class="ftSma">{{$t('help.title1')}}</router-link>
					<!-- <p>|</p>
					<router-link :to="{name:'pcDisclaimers', query: {id:4}}"
						class="ftSma">{{$t('help.title3')}}</router-link> -->
					<p>|</p>
					<router-link :to="{name:'pccontact', query: {id:5}}"
						class="ftSma">{{$t('help.title4')}}</router-link>
					<p>|</p>
					<router-link :to="{name:'pcjoinus', query: {id:6}}"
						class="ftSma">{{$t('help.title5')}}</router-link>
					<!-- <p>|</p>
					<router-link :to="{name:'pcjoinus', query: {id:7}}"
						class="ftSma">{{$t('help.title7')}}</router-link> -->
					<!-- <p>|</p>
					<router-link :to="{name:'pcresponsibility', query: {id:7}}"
						class="ftSma">{{$t('help.title6')}}</router-link> -->
				</div>
				<div class="ftblinebox Huans flexC">
					<div class="ftbline Huans">
						<div class="ftbtitle Huans">{{$t('footer.fkfs')}}</div>
						<div class="flexC ftimgbox">
							<a href="javaScript:;" class="ftptype ptypeimg1"></a>
							<a href="javaScript:;" class="ftptype ptypeimg2"></a>
							<a href="javaScript:;" class="ftptype ptypeimg3"></a>
							<a href="javaScript:;" class="ftptype ptypeimg4"></a>
							<a href="javaScript:;" class="ftptype ptypeimg5"></a>
							<a href="javaScript:;" class="ftptype ptypeimg6"></a>
							<a href="javaScript:;" class="ftptype ptypeimg7"></a>
							<a href="javaScript:;" class="ftptype ptypeimg8"></a>
							<a href="javaScript:;" class="ftptype ptypeimg9"></a>
							<a href="javaScript:;" class="ftptype ptypeimg10"></a>
							<a href="javaScript:;" class="ftptype ptypeimg11"></a>
						</div>
					</div>
				</div>
				<div class="ftblinebox ftmb30 Huans flexC fl-bet">
					<div class="ftbline Huans">
						<div class="ftbtitle Huans">{{$t('footer.partners')}}</div>
						<div class="flexC ftimgbox ftlianimgbox">
							<!-- <a href="javaScript:;" class="ftptype ptypeimg21"></a> -->
							<a href="javaScript:;" class="ftptype ptypeimg22"></a>
							<a href="javaScript:;" class="ftptype ptypeimg23"></a>
							<a href="javaScript:;" class="ftptype ptypeimg24"></a>
							<a href="javaScript:;" class="ftptype ptypeimg25"></a>
							<a href="javaScript:;" class="ftptype ptypeimg26"></a>
							<a href="javaScript:;" class="ftptype ptypeimg27"></a>
							<a href="javaScript:;" class="ftptype ptypeimg28"></a>
							<a href="javaScript:;" class="ftptype ptypeimg29"></a>
							<a href="javaScript:;" class="ftptype ptypeimg30"></a>
							<a href="javaScript:;" class="ftptype ptypeimg31"></a>
							<a href="javaScript:;" class="ftptype ptypeimg32"></a>
							<a href="javaScript:;" class="ftptype ptypeimg33"></a>
							<a href="javaScript:;" class="ftptype ptypeimg34"></a>
							<a href="javaScript:;" class="ftptype ptypeimg35"></a>
							<a href="javaScript:;" class="ftptype ptypeimg36"></a>
							<a href="javaScript:;" class="ftptype ptypeimg37"></a>
							<a href="javaScript:;" class="ftptype ptypeimg38"></a>
						</div>
					</div>
					<div class="ftbline Huans">
						<div class="ftbtitle Huans">{{$t('footer.followUs')}}</div>
						<div class="flexC ftimgbox">
							<a href="javaScript:;" class="ftptype fus1"></a>
							<a href="javaScript:;" class="ftptype fus2"></a>
							<a href="javaScript:;" class="ftptype fus3"></a>
							<a href="javaScript:;" class="ftptype fus4"></a>
							<a href="javaScript:;" class="ftptype fus5"></a>
						</div>
					</div>
				</div>
				<div class="ftblinebox ftmb30 Huans">
					<div class="ftbline">
						<div class="ftbtitle Huans">{{$t('footer.regauth')}}</div>
						<div class="ftbbtm flexC fl-bet">
							<div class="ftbli flexC Huans">
								<div class="flexC ftimgbox">
									<a href="javaScript:;" class="ftptype fus6"></a>
									<span class="ftptxt">{{$t('footer.pagcor')}}</span>
								</div>
								<div class="flexC ftimgbox hftxt">
									<a href="javaScript:;" class="ftptype fus7"></a>
									<div class="ftpfix">21+</div>
									<span class="ftptxt">{{$t('footer.legalage')}}</span>
								</div>
							</div>
							<!-- <div class="ftCtxt">Copyright © 2018-2023 - All Rights Reserved TDBET.</div> -->
							<div class="ftCtxt">Copyright © TDBET All rights reserved.</div>
						</div>
					</div>
				</div>
				<br>
			</div>
		</footer>
		<!-- END footer -->
		<!-- 	<ul class="KEfu">
			<li>
				<a :href='`javascript:window.open("${kfurl}", "livechat", "height=630, width=600, toolbar= no,directions=no,alwaysRaised=yes,hotkeys =yes, menubar=no, scrollbars=no, resizable=no, location=no, status=no,top=100,left=300");`'
					class="KEfua flexC fl-cen"><span class="pciconfont icon-kefu"></span>
					<p>{{$t('footer.service')}}</p>
				</a>
			</li>
			<li @mouseleave="mouseleavefun">
				<a href="javaScript:;" @mouseover="mouseoverfun" class="KEfua flexC fl-cen"><span
						class="pciconfont icon-weixin"></span>
					<p>{{$t('footer.WeChat')}}</p>
				</a>
				<div class="KefD" :class="iswxshow?'KefDo':''">
					<div class="KefM"><img :src="wxurl"></div>
				</div>
			</li>
			<li @mouseleave="qqmouseleavefun">
				<a href="javaScript:;" @mouseover="qqmouseoverfun" class="KEfua flexC fl-cen"><span
						class="pciconfont icon-QQ"></span>
					<p>{{$t('footer.QQ')}}</p>
				</a>
				<div class="KefD" :class="isqqshow?'KefDo':''">
					<div class="KefM"><img :src="qqurl"></div>
				</div>
			</li>
			<li>
				<el-backtop :right="0" class="KEfua flexC fl-cen kftop">
					<a href="javaScript:;" class="KEfua flexC fl-cen kftop">
					<span class="pciconfont icon-fangxiangshang"></span>
					<p>{{$t('footer.TOP')}}</p>
					</a>
				</el-backtop>
			</li>
		</ul> -->
		<div class="float-menu-right">
			<div class="float-menu" :class="!isMenushow?'closed':''">
				<!-- <a :href='`javascript:window.open("${kfurl}", "livechat", "height=630, width=600, toolbar= no,directions=no,alwaysRaised=yes,hotkeys =yes, menubar=no, scrollbars=no, resizable=no, location=no, status=no,top=100,left=300");`'
					class="float-menu__item cs"> -->
				<!-- <img src="/homeStatic/img/icon_cs.48886d29.svg" alt="" class="float-menu__item-icon"> -->
				<!-- 	<span class="float-menu__item-iconfont iconfontll icon-kefuff"></span>
					<span class="float-menu__item-txt text-center">{{$t('footer.cs')}}</span>
				</a> -->
				<!-- @mouseleave="mouseleavefun" @mouseover="mouseoverfun" -->
				<!-- 	<div class="float-menu__item__app">
					<hr> -->
				<a :href='`javascript:window.open("${feixin}", "livechat", "height=630, width=600, toolbar= no,directions=no,alwaysRaised=yes,hotkeys =yes, menubar=no, scrollbars=no, resizable=no, location=no, status=no,top=100,left=300");`'
					class="float-menu__item relative">
					<span class="float-menu__item-iconfont iconfontll icon-fasongff"></span>
					<span class="float-menu__item-txt text-center">{{$t('footer.telegram')}}</span>
					<!-- 二维码弹窗 -->
					<div class="float-menuD" :class="iswxshow?'float-menuDo':''">
						<div class="float-menuM">
							<!-- <img :src="wxurl"> -->
							<img src="@/assets/pc/images/user/KDOUCODEAPP.jpg">
						</div>
					</div>
				</a>
				<div class="menu__toggle">
					<hr>
					<div @mouseleave="netmouseleavefun" class="float-menu__item__app">
						<div @mouseover="netmouseoverfun" class="float-menu__item relative">
							<span class="float-menu__item-iconfont iconfontll icon-wifi"></span>
							<span class="float-menu__item-txt text-center">{{$t('footer.network')}}</span>
							<!-- 网络弹窗 -->
							<div class="net-menuD" :class="isnetshow?'net-menuDo':''">
								<div class="net-menuM">
									<div class="net-ul">
										<div v-for="(item, index) in netlist" :key="index"
											@click.stop="changenet(item, index)" class="net-li flexC fl-bet">
											<div class="net-li-fl flexC">
												<!-- :class="item.curval>200?'on':''" -->
												<p class="net-li-p" :class="item.endVal==minValue?'on':''">
													<!-- 	<span v-change="{eUnit:'ms',eUnit:'s'}" class="net-linum">233</span> -->
													<!-- 	<countTo ref="countToRef" :startVal='item.curval' :endVal='item.endVal' autoplay
														:duration='3000'></countTo> -->
													{{item.curval}}ms
												</p>
												<span class="net-name">{{item.title}}</span>
											</div>
											<span class="net-li-icon iconfontll icon-danxuanweixuan"
												:class="netidx==index?'on icon-danxuanyixuan':''"></span>
										</div>

									</div>
								</div>
							</div>
						</div>

					</div>
					<hr>
					<div v-if="!darkmode" @click.stop="changedark" class="float-menu__item">
						<span class="float-menu__item-iconfont iconfontll icon-heiyemoshi"></span>
						<span class="float-menu__item-txt text-center">{{$t('footer.dark')}}</span>
					</div>
					<div v-else @click.stop="changedark" class="float-menu__item">
						<span class="float-menu__item-iconfont iconfontll icon-baitian"></span>
						<span class="float-menu__item-txt text-center">{{$t('footer.byday')}}</span>
					</div>
					<!-- 	<hr><a :href='`javascript:window.open("${guanlian}", "livechat", "height=630, width=600, toolbar= no,directions=no,alwaysRaised=yes,hotkeys =yes, menubar=no, scrollbars=no, resizable=no, location=no, status=no,top=100,left=300");`' class="float-menu__item">
						<span class="float-menu__item-iconfont iconfontll icon-hezuohuoban"></span>
						<span class="float-menu__item-txt text-center">{{$t('footer.affiliate')}}</span></a> -->
					<hr>
					<div @click.stop="goTop()" v-show="isshowTopbtn" class="float-menu__item relative">
						<span class="float-menu__item-iconfont iconfontll icon-zhiding"></span>
						<span class="float-menu__item-txt text-center">{{$t('footer.TOP')}}</span>
					</div>
				</div>

				<div @click="ToggleMenu" class="close__box">
					<div class="close__bg"></div>
					<div class="close__btn">{{isMenushow?'关闭':'展开'}}</div>
				</div>
			</div>
			<div class="chat">
				<div class="chat-floating cursor-pointer onbet" style="">
					<a :href='`javascript:window.open("${liaotian}", "livechat", "height=630, width=600, toolbar= no,directions=no,alwaysRaised=yes,hotkeys =yes, menubar=no, scrollbars=no, resizable=no, location=no, status=no,top=100,left=300");`'
						class="chat-wrap">
						<span class="float-menu__item-iconfont iconfontll icon-liaotian1"></span>
						<p class="chat-wrap__text">{{$t('footer.chat')}}</p>
					</a>
				</div>
			</div>
		</div>
		<!-- 右侧end -->
		<!-- 左侧vip -->
		<div v-if="isfixImg" class="float-img-fixed ">
			<div @click="golink('/pcvip')" class="float-img monkey monkey-animation">
				<!-- <img src="@/assets/pc/images/icon/vipimg.png"> -->
			</div>
			<div @click="closefixImg" class="float-img-close iconfontll icon-quxiao"></div>
		</div>
		<!-- 优惠活动 -->
		<div v-if="isfixImg1" class="float-img-fixed1">
			<div @click="golink(indexopen)" class="float-img1">
				<img src="@/assets/pc/images/icon/floatimg.png">
			</div>
			<div @click="closefixImg1" class="float-img-close1 iconfontll icon-quxiao"></div>
		</div>
		<!-- usdt右侧货币了解 -->
		<div v-if="isfixImg2" class="float-img-fixed2" :style="dynamicStyle">
			<div @click="golink(indexopen2)" class="float-img2">
				<img src="@/assets/pc/images/icon/hbfdtu.png">
			</div>
			<div @click="closefixImg2" class="float-img-close2 iconfontll icon-quxiao"></div>
		</div>
	</div>
</template>

<script>
	import {
		queryConfig,
		queryNetworks
	} from "@/api/urls";
	import Ping from 'ping.js'; //返回网络状态
	// import countTo from 'vue-count-to';
	export default {
		name: 'Footer',
		inject: [
			'reload'
		],
		components: {
			// countTo
		},
		props: {
			link: {
				type: String,
				default: ""
			}
		},
		data() {
			return {
				isLogin: false, //是否登录
				darkmode: false, //是否夜间模式
				modeicon: require('@/assets/pc/images/icon/sun.svg'),
				modetext: "夜间模式",
				isfixImg: true, //是否显示左侧vip true
				isfixImg1: true, //是否显示左侧元宝
				isfixImg2: true,
				isMenushow: true, //右侧悬浮true
				iswxshow: false, //是否显示微信二维码
				isnetshow: false, //是否显示网络弹窗
				startVal: 0, //数字开始
				endVal: 233, //数字开始
				currentValue0: 0,
				navfag: false, //状态
				netlist: [{
					title: 'Line1',
					endVal: 333,
					curval: 0
				}, {
					title: 'Line2',
					endVal: 178,
					curval: 0
				}, {
					title: 'Line3',
					endVal: 124,
					curval: 0
				}, {
					title: 'Line4',
					endVal: 149,
					curval: 0
				}],
				netidx: 0,
				Config: {},
				kfurl: '', //客服
				feixin: '', //飞信
				guanlian: '', //关联
				liaotian: '', //聊天
				isqqshow: false, //是否显示qq二维码
				wxurl: '', //微信二维码
				qqurl: '', //qq二维码
				indexopen: '',
				indexopen2: '',
				sideTabList: [{
					id: 1,
					title: "关于我们",
					name: "about",
					link: "/about",
					img: require('@/assets/pc/images/icon/con06.png'),
				}, {
					id: 2,
					title: "常见问题",
					name: "problem",
					link: "/problem",
					img: require('@/assets/pc/images/icon/con01.png'),
				}, {
					id: 3,
					title: "隐私政策",
					name: "Policy",
					link: "/Policy",
					img: require('@/assets/pc/images/icon/con03.png'),
				}, {
					id: 4,
					title: "免责说明",
					name: "Disclaimers",
					link: "/Disclaimers",
					img: require('@/assets/pc/images/icon/con04.png'),
				}, {
					id: 5,
					title: "联系我们",
					name: "contact",
					link: "/contact",
					img: require('@/assets/pc/images/icon/con05.png'),
				}, {
					id: 6,
					title: "代理加盟",
					name: "joinus",
					link: "/joinus",
					img: require('@/assets/pc/images/icon/con07.png'),
				}, {
					id: 7,
					title: "博彩责任",
					name: "responsibility",
					link: "/responsibility",
					img: require('@/assets/pc/images/icon/con02.png'),
				}, ],
				sideTaindex: 0,
				sideTaid: 1,
				isshowTopbtn: true, // 控制显示/隐藏“返回顶部”按钮的变量false
			}
		},
		created() {
			var that = this;
			that.getSystem();
			that.getNetworks();

			// 判断是否登录
			// console.log(that.$store.getters['getToken'], "判断是否登录")
			if (that.$store.getters['getToken'] != '') {
				that.isLogin = true;

			} else {
				that.isLogin = false;
			}
			// 获取黑白模式
			var darkmodeval = that.$store.state.darkmode;
			// console.log("darkmodeval", darkmodeval)
			if (darkmodeval != null) {
				that.darkmode = darkmodeval;
				if (darkmodeval) {
					that.modeicon = require('@/assets/pc/images/icon/sun.svg');
					that.modetext = "夜间模式";
					// 挂载后给body添加类名
					document.body.classList.add('darkmode');
					document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-dark.css`);
				} else {
					that.modeicon = require('@/assets/pc/images/icon/moon.svg');
					that.modetext = "白天模式";
					// 挂载后给body添加类名
					document.body.classList.remove('darkmode');
					document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-light.css`);
				}
			}
		},
		computed: {
			dynamicStyle() {
				return {
					bottom: this.isMenushow ? '540px' : '260px',
				};
			},
			// 获取最小值
			 minValue() {
			      return Math.min(...this.netlist.map(item => item.endVal));
			    }
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			handleScroll() {
				if (window.pageYOffset > 100) { // 当滚动超过100px时显示“返回顶部”按钮
					// this.isshowTopbtn = true;
				} else {
					// this.isshowTopbtn = false;
				}
			},
			goTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				}) // 平滑滚动至顶部
			},
			// 点击显示微信二维码图片
			mouseoverfun(e) {
				var that = this;
				// console.log(e, "移入")
				that.iswxshow = true;
				// console.log(that.iswxshow, "移入1")
			},
			mouseleavefun(e) {
				var that = this;
				// console.log(e, "移出")
				that.iswxshow = false;

				// console.log(that.iswxshow, "移出1")
			},
			// 点击显示网络列表
			netmouseoverfun(e) {
				var that = this;
				// console.log(e, "移入")
				that.isnetshow = true;
				if (!that.navfag) {
					that.navfag = true;
					var list = that.netlist;
					for (var i in list) {
						// 开始动画
						list[i].curval = 0;
						var endVal = list[i].endVal;
						that.animateValue(i, endVal);
					}
				}
				// that.reStartCount(); //开始数字
				// that.endVal = 233; //数字开始
				// console.log(that.iswxshow, "移入1")
			},
			netmouseleavefun(e) {
				var that = this;
				// console.log(e, "移出")

				// setTimeout(() => {
				that.isnetshow = false; //关闭弹窗
				that.navfag = false;
				// }, 2000);
				// that.endVal = 0; //数字开始
				// that.reResetCount(); //重置数字
				// console.log(that.iswxshow, "移出1")
			},
			// 点击显示qq二维码图片
			qqmouseoverfun(e) {
				var that = this;
				that.isqqshow = true;
			},
			qqmouseleavefun(e) {
				var that = this;
				that.isqqshow = false;
			},

			// 开始数字
			reStartCount() {
				// this.$refs.countToRef.start();

			},
			// 重置数字
			reResetCount() {
				// this.$refs.countToRef.reset();
			},
			// 数字动画效果
			animateValue(idx, endNum) {
				this.netlist[idx].curval = 0;
				// console.log(idx,endNum,"endNum")
				// if (this.navfag) return;
				// // 最终要显示的数字
				// let finalNum = endNum;
				// // 动画间隔
				// let rate = 30;
				// // 总时长
				// let time =3000;
				// // 步长,数据增加间隔
				// let step = finalNum / (time / rate);
				// // 初始值
				// let count = 0;
				// // 要保留的小数
				// let timer = setInterval(() => {
				// 	count = count + step;
				// 	// this['currentValue'+idx] = count.toFixed(0);
				// 	this.netlist[idx].curval = count.toFixed(0);
				// 	if (count > finalNum) {
				// 		//  避免count大于finalNum最终数字显示不对
				// 		count = finalNum;
				// 		// this['currentValue'+idx]= count;
				// 		this.netlist[idx].curval = count;
				// 		console.log(this['currentValue' + idx])
				// 		// 清空定时器
				// 		clearInterval(timer);
				// 		timer = null;
				// 	}
				// }, rate)
				let count = 0;
				let targetValue = endNum; // 指定值为10，可以根据需要自行修改
				let interval = 100; // 每次递增的时间间隔，单位为毫秒，可以根据需要自行修改
				let increment = targetValue / (3000 / interval); // 计算每次递增的增量
				let timer = setInterval(() => {
					count = Math.min(count + increment, targetValue);
					// console.log(this.netlist[idx].curval,"curval")
					this.netlist[idx].curval = count.toFixed(0);
					if (count >= targetValue) {
						this.netlist[idx].curval = count;
						// this.navfag = false;
						// 清空定时器
						clearInterval(timer);
						timer = null;
					}
				}, interval);
				// this.navfag = true;
			},
			// 网络选择
			changenet(item, index) {
				var that = this;
				that.netidx = index;
				window.location.href = item.url;
			},
			ToggleMenu() {
				var that = this;
				that.isMenushow = !that.isMenushow;
			},
			closefixImg() {
				var that = this;
				that.isfixImg = false;
			},
			closefixImg1() {
				var that = this;
				that.isfixImg1 = false;
			},
			closefixImg2() {
				var that = this;
				that.isfixImg2 = false;
			},
			// 切换黑夜
			changedark() {

				var that = this;
				var darkmodeval = !that.darkmode;
				console.log("darkmodeval", darkmodeval)
				if (!darkmodeval) {
					that.darkmode = false;
					that.$store.commit('setDarkmode', false)
					// 挂载后给body添加类名
					document.body.classList.add('darkmode');
					document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-light.css`);
				} else {
					that.darkmode = true;
					that.$store.commit('setDarkmode', true)
					// 挂载后给body添加类名
					document.body.classList.remove('darkmode');
					document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-dark.css`);

					// that.modeicon = require('@/assets/wap/images/icon/moon.svg');
					// that.modetext = "白天模式";
					// setTimeout(function(){
					//   location.reload() //刷新页面
					// },1000)
				}
				that.reload() //刷新页面
				// location.reload()//刷新页面
			},
			// 获取客服链接
			//获取cs链接
			getSystem() {
				var params = {
					'lang': this.$store.state.lang,
				}
				queryConfig(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.Config = data;
						this.kfurl = data.site_online;
						this.feixin = data.kf_feixin;
						this.guanlian = data.kf_guanlian;
						this.liaotian = data.kf_liaotian;
						this.indexopen = data.index_open;
						this.indexopen2 = data.index_open2;
						// console.log(data, "data")
					}
				})
			},
			getNetworks() {
				var params = {
					'lang': this.$store.state.lang,
				}
				queryNetworks(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						// console.log(data, "Networks_data")
						var wlym = location.origin; //获取当前域名
						// window.location.hostname
						// console.log(wlym, "wlym")
						for (var i in data) {
							data[i]['curval'] = 0;
							data[i]['endVal'] = 0;
							if (wlym == data[i].url) {
								this.netidx = i;
							}
						}
						this.netlist = data;
						// console.log(this.netlist, "netlist")
						this.checkPing()
					}
				})
			},
			// 检查网络
			checkPing() {
				const p = new Ping();
				var urls = this.netlist;
				urls.forEach(function(item) {
					// console.log(item, "item")
					let url = item.url;
					p.ping(url, function(err, data) {
						if (err) {
							// console.error(err, 'Error');
							item.endVal = 0;
						} else {
							// console.log(data + ' ms');
							item.endVal = data;
						}
					});

				});
				this.netlist = urls;
				console.log(this.netlist, "netlist1")
			},
			// 跳转外链
			golink(url) {
				if (url == '/pcvip') {
					if (this.isLogin == false) {
						this.$message.error(this.$t('message.plogin'));
						return false;
					}
					this.$router.push({
						path: url,
					})
					return false
				}
				window.open(url, '_blank')
			},
			// gokefu(url) {
			// 	// window.localtion.href =url;
			// 	location.href = url;
			// }
		}
	}
</script>

<style scoped>
	/* 返回顶部 */
	.el-backtop {
		position: static;
		border-top-right-radius: 0px;
		border-bottom-right-radius: 0px;
	}
</style>


// WEBPACK FOOTER //
// src/components/pc/public/Footer.vue